import api from '../utils/api';

export const addMessage = async (question, chat, attachments, messageMetadata = null, filesMetadata = null, fileSpecificMetadata = null) => {
  const endpoint = `cognitive/chats/${chat}/`;

  const formData = new FormData();
  formData.append("message", question);

  // Add message metadata if provided
  if (messageMetadata && Object.keys(messageMetadata).length > 0) {
    formData.append("metadata", JSON.stringify(messageMetadata));
  }

  // Helper function to convert metadata cards to object
  const convertCardsToObject = (cards) => {
    const obj = {};
    if (cards && cards.length > 0) {
      cards.forEach(card => {
        if (card.key && card.values) {
          obj[card.key] = card.values.length === 1 ? card.values[0] : card.values;
        }
      });
    }
    return obj;
  };

  // Convert global metadata cards to object
  const globalMetadataObject = convertCardsToObject(filesMetadata);

  if (attachments != null) {
    if (Array.isArray(attachments)) {
      // Append as file_1, file_2, file_3, etc.
      attachments.forEach((file, index) => {
        formData.append(`file_${index + 1}`, file);
        
        // Start with global metadata
        const fileMetadataObject = { ...globalMetadataObject };
        
        // Check for file-specific metadata (by file name)
        if (fileSpecificMetadata && fileSpecificMetadata[file.name]) {
          const specificCards = fileSpecificMetadata[file.name];
          const specificObj = convertCardsToObject(specificCards);
          // Specific metadata overrides global
          Object.assign(fileMetadataObject, specificObj);
        }
        
        // Only send if there's metadata
        if (Object.keys(fileMetadataObject).length > 0) {
          formData.append(`metadata_${index + 1}`, JSON.stringify(fileMetadataObject));
        }
      });
    } else {
      formData.append("file_1", attachments);
      
      // Start with global metadata
      const fileMetadataObject = { ...globalMetadataObject };
      
      // Check for file-specific metadata
      if (fileSpecificMetadata && fileSpecificMetadata[attachments.name]) {
        const specificCards = fileSpecificMetadata[attachments.name];
        const specificObj = convertCardsToObject(specificCards);
        Object.assign(fileMetadataObject, specificObj);
      }
      
      if (Object.keys(fileMetadataObject).length > 0) {
        formData.append("metadata_1", JSON.stringify(fileMetadataObject));
      }
    }
  }

  const resp = await api.post(endpoint, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    }
  });
  return resp;
};

export const addMessageAsync = async (question, chat, attachments, messageMetadata = null, filesMetadata = null, fileSpecificMetadata = null) => {
  const endpoint = `cognitive/chats/${chat}/async/`;

  const formData = new FormData();
  formData.append("message", question);

  // Add message metadata if provided
  if (messageMetadata && Object.keys(messageMetadata).length > 0) {
    formData.append("metadata", JSON.stringify(messageMetadata));
  }

  // Helper function to convert metadata cards to object
  const convertCardsToObject = (cards) => {
    const obj = {};
    if (cards && cards.length > 0) {
      cards.forEach(card => {
        if (card.key && card.values) {
          obj[card.key] = card.values.length === 1 ? card.values[0] : card.values;
        }
      });
    }
    return obj;
  };

  // Convert global metadata cards to object
  const globalMetadataObject = convertCardsToObject(filesMetadata);

  if (attachments != null) {
    if (Array.isArray(attachments)) {
      // Append as file_1, file_2, file_3, etc.
      attachments.forEach((file, index) => {
        formData.append(`file_${index + 1}`, file);

        // Start with global metadata
        const fileMetadataObject = { ...globalMetadataObject };

        // Check for file-specific metadata (by file name)
        if (fileSpecificMetadata && fileSpecificMetadata[file.name]) {
          const specificCards = fileSpecificMetadata[file.name];
          const specificObj = convertCardsToObject(specificCards);
          // Specific metadata overrides global
          Object.assign(fileMetadataObject, specificObj);
        }

        // Only send if there's metadata
        if (Object.keys(fileMetadataObject).length > 0) {
          formData.append(`metadata_${index + 1}`, JSON.stringify(fileMetadataObject));
        }
      });
    } else {
      formData.append("file_1", attachments);

      // Start with global metadata
      const fileMetadataObject = { ...globalMetadataObject };

      // Check for file-specific metadata
      if (fileSpecificMetadata && fileSpecificMetadata[attachments.name]) {
        const specificCards = fileSpecificMetadata[attachments.name];
        const specificObj = convertCardsToObject(specificCards);
        Object.assign(fileMetadataObject, specificObj);
      }

      if (Object.keys(fileMetadataObject).length > 0) {
        formData.append("metadata_1", JSON.stringify(fileMetadataObject));
      }
    }
  }

  const resp = await api.post(endpoint, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    }
  });
  return resp;
};

const MessagesApi = {
  addMessage,
  addMessageAsync,
};

export default MessagesApi;